import type { ImageSizesHelperParams } from '@ori/image-sizes-helper';
import { getImageVariants, generateSrcSet } from '@ori/image-sizes-helper';
import type { VFC } from 'react';

interface ArticleImageProps {
  image: string;
  name?: string;
}

export const AboutTileImage: VFC<ArticleImageProps> = ({ image, name }) => {
  const imagesVariants: ImageSizesHelperParams = {
    url: image,
    params: [
      {
        width: 452,
        height: 452,
        quality: 90,
      },
    ],
  };
  const images = getImageVariants(imagesVariants);

  return (
    <img
      src={image}
      alt={name}
      sizes="452px"
      srcSet={generateSrcSet(images)}
    />
  );
};
